export const genRandId = (): string =>
  Date.now().toString(36) + Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36);

export const humanFileSize = (bytes: number) => {
  const thresh = 1000;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let u = -1;
  const r = 10 ** 0;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

  return bytes.toFixed(0) + units[u];
};

/**
 * Recursively extracts plain text from a ProseMirror JSON structure.
 * This replaces the need for div.innerHTML / div.innerText.
 */
export const getProseMirrorText = (node: any): string => {
  if (!node) return '';

  // If it's a leaf text node, return the text
  if (node.text) {
    return node.text;
  }

  // If it's a container node, recurse through children
  if (Array.isArray(node.content)) {
    return node.content.map(getProseMirrorText).join('');
  }

  // Handle the top-level 'doc' or fragments wrapped in objects
  if (node.type === 'doc' && node.content) {
    return node.content.map(getProseMirrorText).join('');
  }

  return '';
};
